export const HOST = process.env.NEXT_PUBLIC_HOST;
export const IVA = 19;
export const IMPOCONSUMO = 8;
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;

// FIREBASE
export const FIREBASE_VAPID_KEY = process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY;
export const FIREBASE_API_KEY = process.env.NEXT_PUBLIC_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.NEXT_PUBLIC_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.NEXT_PUBLIC_PROJECT_ID;
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.NEXT_PUBLIC_APP_ID;
export const FIREBASE_MEASUREMENT_ID = process.env.NEXT_PUBLIC_MEASUREMENT_ID;

// FIREBASE AUTH
export const FIREBASE_AUTH_STORAGE_BUCKET =
  process.env.NEXT_PUBLIC_STORAGE_BUCKET;

//WOMPI
export const WOMPI_API = process.env.NEXT_PUBLIC_WOMPI_API;
export const WOMPI_PUBLIC_KEY = process.env.NEXT_PUBLIC_WOMPI_PUBLIC_KEY;

//Mercado Pago
export const MP_API = process.env.NEXT_PUBLIC_MERCADO_PAGO_API ?? "";
export const MP_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_MERCADO_PAGO_PUBLIC_KEY ?? "";

//Open Weather
export const OPEN_WEATHER_API = process.env.NEXT_PUBLIC_OPEN_WEATHER_API ?? "";

//DOWNLOAD alegriia-printer
// Hosted outside the repo (S3) to keep the ~100MB installer out of git
export const PRINTER_INSTALLER_URL =
  process.env.NEXT_PUBLIC_PRINTER_INSTALLER_URL ?? "";
